export default "__VITE_ASSET__22957563__"